// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Conflict-resolution policy applied when multiple MERGE/MIXED endpoints
 * emit differing values for the same field within a debounce window.
 *
 * Only LAST_WRITE_WINS is implemented in v1; others are schema-reserved.
 */
export enum MergePolicy {
  LAST_WRITE_WINS = 0,
  PRIMARY_PREFERRED = 1,
  QUORUM = 2,
}
